// src/store/compressSlice.js
import { createSlice } from "@reduxjs/toolkit";

const openSearchUpdationSlice = createSlice({
  name: "openSearch",
  initialState: {
    isActiveLostTriggered: false,
  },
  reducers: {
    setIsActiveLostTrigger: (state, action) => {
      state.isActiveLostTriggered = action.payload;
    },
  },
});

export const { setIsActiveLostTrigger } = openSearchUpdationSlice.actions;

export default openSearchUpdationSlice.reducer;
